import { useState, useEffect } from 'react';
import { API } from 'aws-amplify';
import { hydrateEntry } from './hydrateEntry';

/**
 * Custom React hook to fetch a single Contentful entry by ID.
 * @param {string} id - The Contentful entry ID.
 * @returns {object} { entry, loading, error }
 */
export function useContentfulEntry(idOrQuery) {
  const [entry, setEntry] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!idOrQuery) {
      setEntry(null);
      setLoading(false);
      setError(null);
      return;
    }

    setLoading(true);
    setError(null);

    // If idOrQuery is a string, treat as sys.id; otherwise, use as query object
    const queryParams = typeof idOrQuery === 'string'
      ? { 'sys.id': idOrQuery }
      : idOrQuery;

    API.get('content', '/content', { queryStringParameters: queryParams })
      .then((result) => {
        if (result && result.items && result.items.length > 0) {
          const mainEntry = result.items[0];

          const includes = result.includes || {};
          hydrateEntry(mainEntry, includes);
          setEntry({ ...result, items: [mainEntry] });
        } else {
          setEntry(result);
        }
        setLoading(false);
      })
      .catch((err) => {
        setError(err);
        setEntry(null);
        setLoading(false);
      });
  }, [idOrQuery]);

  return { entry, loading, error };
}
